import axios from "axios";

export default {
  namespaced: true,
  state: {
    image: null,
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    imagesMessage: ''
  },
  mutations: {
    RECEIVED_IMAGES(state, payload) {
      state.images = payload;
      state.isReceiving = false;
    },
    RECEIVED_IMAGE(state, payload) {
      state.image = payload;
    },
    RECEIVING_IMAGES(state) {
      state.isReceiving = true;
    },
    RECEIVING_IMAGE(state) {
      state.isReceiving = true;
    },
    UPDATED_IMAGE(state, payload) {
      let index = state.images.findIndex(image => image._id === payload._id);
      state = Object.assign(state, {
        images: state.images.map((image, i) => {
          if (i === index) {
            return Object.assign({}, image, payload);
          }
          return image;
        }),
        isUpdating: false,
        imagesMessage: 'Images has been updating!',
      })
    },
    UPDATING_IMAGE(state) {
      state.isUpdating = true;
    },
    DELETED_IMAGE(state, payload) {
      let indexToDelete = state.images.findIndex(image => image._id === payload._id);
      let images = [...state.images];
      images.splice(indexToDelete, 1);
      state = Object.assign(state, {
        images: [...images],
        isDeleting: false,
        idToDelete: null,
        imagesMessage: 'Image has been Deleted!',
      });
    },
    DELETING_IMAGE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingImage");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/image/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        console.log(response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertRouteImage({dispatch}, payload) {
      try{
        if(payload.image == undefined || payload.image == null) return;
        console.log(payload)
        dispatch("receivingImages");
        let token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/image/route/' + payload.id;
        let data = new FormData();
        data.append('image', payload.image); 
        delete payload['image'];
        delete payload['id'];
        for (let x in payload) data.append(x, payload[x]);
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getDownloadImage({dispatch}, url){
      dispatch("updatingImage");
      const response = await fetch(url);
      let data = await response.blob();
      let blob = new Blob([data], { type: 'application/pdf' });
      let imagesrc = URL.createObjectURL(blob);
      return imagesrc;
    },
    receivedImages({commit}, payload) {
      commit("RECEIVED_IMAGES", payload)
    },
    receivingImages({commit}) {
      commit("RECEIVING_IMAGES")
    },
    receiveImage({commit}, payload) {
      commit("RECEIVED_IMAGE", payload)
    },
    receivingImage({commit}) {
      commit("RECEIVING_IMAGE")
    },
    updateImage({commit}, payload) {
      commit("UPDATED_IMAGE", payload)
    },
    updatingImage({commit}) {
      commit("UPDATING_IMAGE")
    },
    deleteImage({commit}, payload) {
      commit("DELETED_IMAGE", payload)
    },
    deletingImage({commit}, payload) {
      commit("DELETING_IMAGE", payload)
    }
  },
};
